import { Typography, Box, CircularProgress } from '@mui/material';
import { useAppSelector } from '../../state/hooks';
import { selectIsLoginProgress } from '../../features/auth/authSlice';

const AuthenticationProgress = () => {
  const isLoginProgress = useAppSelector(selectIsLoginProgress);
  return (
    isLoginProgress && (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        zIndex="1000"
      >
        <CircularProgress />
        <Box mt={2}>
          <Typography variant="h6" component="div">
            Authentication in progress...
          </Typography>
        </Box>
      </Box>
    )
  );
};

export default AuthenticationProgress;
